import { ValidationSchema } from '../../../types';
import { BusinessAuthorisationModel } from '../../../containers/manageAccess/types';
import { organisationRoleValidator } from '../createBusinessAuthorisation';

export const updateBusinessOrganisation: ValidationSchema<Partial<BusinessAuthorisationModel>> = () => {
    return {
        organisationRole: organisationRoleValidator,
    };
};
